"use client";

import { useSyncExternalStore } from "react";
import { unlock } from "./fun/achievements";

// Корзина демо-магазина: хранится в localStorage этого браузера, общая для всех страниц.
// bundle — позиция из блока «Соберите экспедицию», считается со скидкой BUNDLE_OFF
export type CartLine = { slug: string; variant: string; qty: number; bundle?: boolean };
export const BUNDLE_OFF = 0.1;

const KEY = "nii-cart-v1";
const OPEN_EVENT = "nii:cart-open";
let lines: CartLine[] = [];
let loaded = false;
const listeners = new Set<() => void>();

function load() {
  if (loaded || typeof window === "undefined") return;
  loaded = true;
  try {
    const saved = JSON.parse(localStorage.getItem(KEY) || "[]");
    if (Array.isArray(saved)) lines = saved.filter((l) => l && typeof l.slug === "string" && l.qty > 0);
  } catch {
    /* без сохранения корзина всё равно работает */
  }
}

function emit(next: CartLine[]) {
  lines = next;
  try {
    localStorage.setItem(KEY, JSON.stringify(lines));
  } catch {
    /* см. выше */
  }
  listeners.forEach((l) => l());
}

export const cart = {
  add(slug: string, variant: string, qty = 1, bundle = false) {
    load();
    unlock("sponsor");
    const same = (l: CartLine) => l.slug === slug && l.variant === variant && !!l.bundle === bundle;
    const found = lines.find(same);
    emit(found ? lines.map((l) => (l === found ? { ...l, qty: Math.min(99, l.qty + qty) } : l)) : [...lines, { slug, variant, qty, ...(bundle ? { bundle } : {}) }]);
  },
  set(line: CartLine, qty: number) {
    const same = (l: CartLine) => l.slug === line.slug && l.variant === line.variant && !!l.bundle === !!line.bundle;
    emit(qty <= 0 ? lines.filter((l) => !same(l)) : lines.map((l) => (same(l) ? { ...l, qty: Math.min(99, qty) } : l)));
  },
  clear() {
    emit([]);
  },
  open() {
    window.dispatchEvent(new Event(OPEN_EVENT));
  },
  onOpen(fn: () => void) {
    window.addEventListener(OPEN_EVENT, fn);
    return () => window.removeEventListener(OPEN_EVENT, fn);
  },
};

const EMPTY: CartLine[] = [];
export function useCart() {
  return useSyncExternalStore(
    (fn) => {
      load();
      listeners.add(fn);
      fn();
      return () => listeners.delete(fn);
    },
    () => lines,
    () => EMPTY
  );
}
